import { Component, OnDestroy, OnInit } from "@angular/core";
import { Subscription } from "rxjs";

import { NgxSpinnerService } from "ngx-spinner";
import { DynamicScriptLoaderService } from "src/app/shared/services/dynamic-script-loader.service";
import { IAccount } from "src/app/_models/account/IAccount";
import { IArticle } from "src/app/_models/article/IArticle";
import { AuthenticationService } from "src/app/_services/authentication.service";
import { NotificationService } from "src/app/_services/notification.service";
import { IdleService } from "src/app/_services/idle.service";
import { DeviceDetectorService } from "ngx-device-detector";
import { ConfigurationService } from "src/app/_services/configuration.service";
import { IConfiguration } from "src/app/_models/configuration/IConfiguration";
import { environment } from "src/environments/environment";

@Component({
  selector: "app-landing-header",
  templateUrl: "./landing-header.component.html",
  styleUrls: ["./landing-header.component.scss"],
})
export class LandingHeaderComponent implements OnInit, OnDestroy {
  subscriptions = new Subscription();
  articles: IArticle[] = [];
  account: IAccount;
  readyToShow = false;
  readyToChangeZindex = false;
  isMobile = false;
  configurations: IConfiguration[] = [];
  customPublicInterface = false;
  clinicName = "";

  constructor(
    private dynamicScriptLoader: DynamicScriptLoaderService,
    private authenticationService: AuthenticationService,
    private notificationService: NotificationService,
    private spinner: NgxSpinnerService,
    private idleService: IdleService,
    private device: DeviceDetectorService,
    private configurationService: ConfigurationService
  ) {}

  ngOnInit() {
    this.isMobile = this.device.isMobile();
    this.spinner.show();

    const sub = this.authenticationService.account.subscribe(
      res => {
        if (res) {
          this.account = this.authenticationService.getAccount();

          // pornim monitorizarea idle
          if (!this.idleService.started) {
            this.idleService.isLandingPage = true;
            this.idleService.start();
          }
        } else {
          delete this.account;
        }
      });
    this.subscriptions.add(sub);

    // custom public interface
    if (environment.customInterface) {
      this.customPublicInterface = true;
    }

    this.loadStyles();
    this.loadScripts();
    this.getConfigurations();

    setTimeout(() => {
      this.readyToShow = true;
      this.spinner.hide();
    }, 1200);
    setTimeout(() => {
      this.readyToChangeZindex = true;
    }, 1350);
  }

  ngOnDestroy() {
    this.subscriptions.unsubscribe();
  }

  logout() {
    const sub = this.authenticationService.doLogoutOnly().subscribe(
      () => {
        this.spinner.hide();
      },
      (error) => {
        if (error) {
          this.notificationService.showError(error);
          this.spinner.hide();
        }
      }
    );
    this.subscriptions.add(sub);
  }

  private async loadStyles() {
    await this.dynamicScriptLoader
      .loadS("bootstrap")
      .catch((error) => console.log(error));

    await this.dynamicScriptLoader
      .loadS("icofont")
      .catch((error) => console.log(error));

    await this.dynamicScriptLoader
      .loadS("boxicons")
      .catch((error) => console.log(error));

    await this.dynamicScriptLoader
      .loadS("carousel")
      .catch((error) => console.log(error));

    await this.dynamicScriptLoader
      .loadS("venobox")
      .catch((error) => console.log(error));

    await this.dynamicScriptLoader
      .loadS("aos")
      .catch((error) => console.log(error));

    await this.dynamicScriptLoader
      .loadS("style")
      .catch((error) => console.log(error));
  }

  private async loadScripts() {
    await this.dynamicScriptLoader
      .load("jquery")
      .catch((error) => console.log(error));

    await this.dynamicScriptLoader
      .load("bootstrap")
      .catch((error) => console.log(error));

    await this.dynamicScriptLoader
      .load("easing")
      .catch((error) => console.log(error));

    await this.dynamicScriptLoader
      .load("carousel")
      .catch((error) => console.log(error));

    await this.dynamicScriptLoader
      .load("venobox")
      .catch((error) => console.log(error));

    await this.dynamicScriptLoader
      .load("aos")
      .catch((error) => console.log(error));

    await this.dynamicScriptLoader
      .load("main")
      .catch((error) => console.log(error));
  }

  private getConfigurations() {
    const sub = this.configurationService.getConfigurations(true).subscribe(
      (res: IConfiguration[]) => {
        this.configurations = res;

        this.setElements();
      });
    this.subscriptions.add(sub);
  }

  private setElements() {
    let clinicNameConfig = this.configurations.find(x => x.key === 'clinicName');
    if (clinicNameConfig && clinicNameConfig.value != "") {
      this.clinicName = clinicNameConfig.value;
    }
  }
}
